export default __webpack_public_path__ + "static/media/bath.0a2a9e29.jpg";